import React, {useState} from 'react';

const ErrorContext = React.createContext({});

const ErrorContextProvider = (props) => {
    const [isMainSuccess, setIsMainSuccess] = useState(false);
    const [isMainLoading] = useState(false);
    const [errors, setErrors] = useState([]);

    const setError = (errorMessage) => {
        setErrors([...errors, errorMessage]);
        setTimeout(() => setErrors([]), 500);
    }

    const success = () => {
        setIsMainSuccess(true);
        setTimeout(() =>setIsMainSuccess(false), 500);
    }

    return (
        <ErrorContext.Provider value={{isMainSuccess, isMainLoading, errors, setError, success}}>
            {props.children}
        </ErrorContext.Provider>
    );
    
  }

export {ErrorContext, ErrorContextProvider};


// WEBPACK FOOTER //
// ./src/Contexts/ErrorContext.js